import { FC, useState, useRef, useEffect } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { isEmpty, get, isNil } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector } from 'react-redux';

import {
  ButtonsWrapper,
  StyledArrowForwardIos,
} from 'containers/ExpertExpertise/ConcernedExpertise/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/ConcernedExpertise/messages';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';

import FillExpertise from 'containers/ExpertExpertise/FillExpertise/index';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import {
  DOCUMENT_INIT_STATE,
  MISSION_EXPERTISE_VICTIM_TYPE,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  uploadDocument,
  resetUploadDocumentStore,
} from 'containers/UploadDocuments/actions';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { FeeNoteType, VictimType } from 'typings/globalTypes';
import {
  expertiseDocumentValidator,
  getPendingFeeNotesByExpertise,
  medicalExpertisesValidator,
} from 'containers/ExpertExpertise/ConcernedExpertise/utils';
import { requestUpdateMissionExpertise } from 'containers/ExpertExpertise/actions';
import { MISSION_EXPERISE_VICTIM_STATUS } from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
import { getLimitInvoiceIntervenant } from 'services/utils';
import moment from 'moment';

export interface RecapExpertiseProps {
  intl: IntlShape;
  uploadedDocument: IUploadedDocument;
  documentIdStore: string;
  victim: VictimType;
  mission: any;
  expertiseVictim: any;
  sagis_code: any;
  requestUpdateMissionExpertise: Function;
  index: any;
  setAllConsultinExpertise: any;
  allConsultinExperise: any;
  consultingExpertise: any;
  thirdPartyAppealsItems: any;
  pretiumDolorisItems: any;
  aestheticDamageWithoutConsequenceItems: any;
  aestheticDamageWithConsequenceItems: any;
  careerPrejudiceItems: any;
  schoolingPrejudiceItems: any;
  listings: any;
  vehicle: any;
  requestGetDocByDocumentumId: Function;
  claimNumber: string;
  lossDate: Date;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
}

const RecapExpertise: FC<RecapExpertiseProps> = (props): JSX.Element => {
  const { uploadedDocument, documentIdStore, victim } = props;
  const [hideButton, setHideButton] = useState(false);
  const [missionDate, setMissionDate] = useState(null);
  const [consultingDocument, setConsultingDocument] = useState<
    JudgementOnMeritsDoc
  >(DOCUMENT_INIT_STATE);
  const [
    formBodyConsultingExpertise,
    setFormBodyConsultingExpertise,
  ] = useState({});
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  const [invoiceDocument, setInvoiceDocument] = useState({});
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const feeNotes: any = getPendingFeeNotesByExpertise(
    feeNotesStore,
    get(formBodyConsultingExpertise, 'id', null),
  );
  const [
    openInvoiceUpdateFeeNoteInfoDialog,
    setOpenInvoiceUpdateFeeNoteInfoDialog,
  ] = useState(false);
  useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);
  useDeepCompareEffect(() => {
    if (!isEmpty(props.expertiseVictim)) {
      setFormBodyConsultingExpertise({
        ...props.expertiseVictim,
        victimIncome: props.expertiseVictim?.victimRevenue,
      });
      setMissionDate(get(props.mission, 'missionDate'));
      if (!get(consultingDocument, 'name')) {
        setConsultingDocument({
          ...props.expertiseVictim?.document,
          response: props.expertiseVictim?.document?.url,
          url: props.expertiseVictim?.document?.url,
        } as any);
      }
      if (
        props.expertiseVictim?.status ===
          MISSION_EXPERISE_VICTIM_STATUS.REJECTED &&
        props.expertiseVictim?.createdBy === props.sagis_code
      ) {
        setHideButton(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.expertiseVictim]);

  const handleSetExpertise = (form: any) => {
    setFormBodyConsultingExpertise(form);
    props.allConsultinExperise[props.index] = { ...form };
    props.setAllConsultinExpertise([...props.allConsultinExperise]);
  };

  const handleSetDoc = (document: any) => {
    props.allConsultinExperise[props.index].document = {
      ...document,
      response: document?.url,
    };
    props.setAllConsultinExpertise([...props.allConsultinExperise]);
    setConsultingDocument({ ...document, response: document?.url });
  };

  let validateExpertise = {};
  if (props.consultingExpertise) {
    validateExpertise = medicalExpertisesValidator(props.consultingExpertise);
  }
  let validateDocumentExpertise = {};
  if (consultingDocument) {
    validateDocumentExpertise = expertiseDocumentValidator(consultingDocument);
  }

  const filtredVictim = props.mission?.missionVictim?.find(
    (element: any) => element?.victimId === get(victim, 'id'),
  );
  const handleUpdateMission = (updatedInvoiceFeeNotes?: any) => {
    props.requestUpdateMissionExpertise(
      {
        ...formBodyConsultingExpertise,
        victimRevenue: get(formBodyConsultingExpertise, 'victimIncome')
          ? get(formBodyConsultingExpertise, 'victimIncome')
          : null,
        document: {
          ...consultingDocument,
          response: null,
          isUpdated: true,
        },
        status: MISSION_EXPERISE_VICTIM_STATUS.PENDING,
        missionVictimId: get(filtredVictim, 'id'),
        missionId: props.mission?.id,
        claimId: props.mission?.claimId,
        missionDate: missionDate,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        invoiceFeeNotes: updatedInvoiceFeeNotes,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBackUpdate,
    );
  };
  const onSubmit = () => {
    if (get(formBodyConsultingExpertise, 'id', null)) {
      if (
        featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
        !isEmpty(feeNotes) &&
        currentIntervenantStorage.get()
      ) {
        setOpenInvoiceUpdateFeeNoteInfoDialog(true);
      } else {
        handleUpdateMission();
      }
    }
  };
  const handleCloseInvoiceUpdateFeeNote = () => {
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
  };
  const handleValidateUpdateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocument,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumber(null);
    setInvoiceDocument({});
    setInvoiceDate(null);
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleUpdateMission(updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    }
  };

  const successCallBackUpdate = () => {
    toast.success(translate(messages.successMessageUpdate, props));
    setHideButton(false);
  };
  let content;
  if (props.consultingExpertise || !isEmpty(props.expertiseVictim))
    content = (
      <>
        <FillExpertise
          formBody={formBodyConsultingExpertise as any}
          setFormBody={handleSetExpertise}
          documentIdStore={documentIdStore}
          setFormBodyConsultingExpertise={setFormBodyConsultingExpertise}
          uploadedDocument={
            props.expertiseVictim &&
            get(props.expertiseVictim, 'status') ===
              MISSION_EXPERISE_VICTIM_STATUS.VALIDATED
              ? (consultingDocument as any)
              : uploadedDocument
          }
          documentId={props.index + 9}
          title={
            props.expertiseVictim?.type ===
            MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
              ? translate(messages.appreciationExpertise, props)
              : translate(messages.consultingExpertise, props)
          }
          document={consultingDocument}
          setDocument={handleSetDoc}
          victim={victim}
          validateExpertise={validateExpertise}
          validateDocumentExpertise={validateDocumentExpertise}
          isReadOnly={
            props.expertiseVictim?.status ===
              MISSION_EXPERISE_VICTIM_STATUS.REJECTED &&
            props.expertiseVictim?.createdBy === props.sagis_code
              ? false
              : true
          }
          thirdPartyAppealsItems={props.thirdPartyAppealsItems}
          pretiumDolorisItems={props.pretiumDolorisItems}
          aestheticDamageWithoutConsequenceItems={
            props.aestheticDamageWithoutConsequenceItems
          }
          aestheticDamageWithConsequenceItems={
            props.aestheticDamageWithConsequenceItems
          }
          careerPrejudiceItems={props.careerPrejudiceItems}
          schoolingPrejudiceItems={props.schoolingPrejudiceItems}
          listings={props.listings}
          sagis_code={props.sagis_code}
          mission={props.mission}
          vehicle={props.vehicle}
          missionDate={missionDate}
          setMissionDate={setMissionDate}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          claimNumber={props.claimNumber}
          lossDate={props.lossDate}
        />
        {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
        !isEmpty(feeNotes) &&
        feeNotes ? (
          feeNotes.map((item: FeeNoteType) => (
            <InvoiceInfoDialog
              open={openInvoiceUpdateFeeNoteInfoDialog}
              onClose={handleCloseInvoiceUpdateFeeNote}
              handleValidate={handleValidateUpdateInvoice}
              invoiceNumber={invoiceNumber}
              invoiceDate={invoiceDate}
              setInvoiceNumber={setInvoiceNumber}
              setInvoiceDate={setInvoiceDate}
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={uploadedDocument}
              invoiceDocument={invoiceDocument}
              setInvoiceDocument={setInvoiceDocument}
              displayUpdateTitle={true}
              isManager={false}
              limitInvoiceDate={getLimitInvoiceIntervenant(
                get(props.listings, 'appConfig', []),
              )}
            />
          ))
        ) : (
          <></>
        )}
        {hideButton && (
          <ButtonsWrapper>
            <SecondaryButton title={translate(messages.back, props)} />
            <PrimaryButton
              title={translate(messages.confirm, props)}
              onClick={() => onSubmit()}
              righticon={<StyledArrowForwardIos className="arrowForward" />}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              disabled={
                !isEmpty(validateDocumentExpertise) ||
                (!isNil(missionDate) && missionDate === 'Invalid date')
              }
              style={{
                padding: 12,
              }}
            />
          </ButtonsWrapper>
        )}
      </>
    );
  return <>{content}</>;
};

const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentIdStore: makeSelectDocumentId(),
});
const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  requestUpdateMissionExpertise,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RecapExpertise));
